import { defineAsyncComponent } from 'vue'
export default {
  blog: defineAsyncComponent(() => import("/home/runner/work/site-movimento/site-movimento/layouts/blog.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/runner/work/site-movimento/site-movimento/layouts/default.vue").then(m => m.default || m))
}